<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <h2 matDialogTitle class="text-center">{{ title }}</h2>
  <mat-dialog-content>
    <app-dynamic-form-question *ngFor="let question of questions" [question]="question" [form]="form"></app-dynamic-form-question>
  </mat-dialog-content>
  <mat-dialog-actions align="end" [ngClass]=AppConfig.theme>
    <button mat-button type="button" color="secondary" matDialogClose>취소</button>
    <button mat-button type="submit" color="primary" [disabled]="!form.valid">확인</button>
  </mat-dialog-actions>
</form>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/dynamic-form-dialog/dynamic-form-dialog.component.html